import React from 'react';
import { Home, Coffee, Users, ShoppingBag } from 'lucide-react';
import { Button } from '../ui/button';

export function Sidebar({ isOpen, activeTab, onTabChange, onClose }) {
  const menuItems = [
    { id: 'pos', label: 'POS', icon: Home },
    { id: 'tables', label: 'Mesas', icon: Coffee },
    { id: 'customers', label: 'Clientes', icon: Users },
    //{ id: 'products', label: 'Productos', icon: ShoppingBag },
  ];

  const handleTabClick = (tabId) => {
    onTabChange(tabId);
    onClose();
  };

  return (
    <>
      {/* Overlay */}
      <div
        className={`fixed inset-0 bg-black/50 transition-opacity duration-300 md:hidden ${
          isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
        onClick={onClose}
      />

      {/* Sidebar */}
      <div
        className={`fixed inset-y-0 left-0 w-64 bg-white shadow-xl transform transition-transform duration-300 ease-in-out z-50 ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="h-14 flex items-center px-4 border-b">
          <h1 className="text-xl font-semibold">Menú</h1>
        </div>

        <nav className="p-4 space-y-2">
          {menuItems.map(({ id, label, icon: Icon }) => (
            <Button
              key={id}
              variant={activeTab === id ? 'default' : 'ghost'}
              className="w-full justify-start gap-3"
              onClick={() => handleTabClick(id)}
            >
              <Icon size={20} />
              {label}
            </Button>
          ))}
        </nav>
      </div>
    </>
  );
}